const TIPOS_PLATAFORMA = [
  {
    label: 'Android',
    value: 0,
  },
  {
    label: 'IOS',
    value: 1,
  },
]
  
export {
  TIPOS_PLATAFORMA
}
